import React, {forwardRef} from 'react';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import styles from '../styles/triggerButton.module.scss';
import classnames from 'classnames';

type Props = {
    icon: PriorityIcon;
    onClick: () => void;
    isActive: boolean;
    disabled: boolean;
    className?: string;
};

export const TriggerButton = forwardRef<HTMLDivElement, Props>(
    ({icon, onClick, isActive, disabled, className}, ref) => {
        return (
            <div ref={ref}>
                <Icon
                    icon={icon}
                    disabled={disabled}
                    iconColor={isActive ? 'primary-500' : 'white'}
                    componentClasses={classnames(
                        styles.triggerIcon,
                        {[styles.activeTriggerIcon]: isActive},
                        {[styles.disabledButtons]: disabled},
                        className
                    )}
                    onClick={onClick}
                />
            </div>
        );
    }
);
